import { useMemo } from 'react'
import {
  Button,
  BUTTON_TYPES,
  TButtonOptionProps
} from '../../../components/Button'
import { BTN_TXT } from '../../../constants'
import { ReactComponent as More16 } from 'assets/svg/More16.svg'
import { ActionsCellProps } from './types'

export const ActionsCell = ({
  setSelectedCC,
  cc,
  canDelete,
  canManageAssignment,
  onDeleteCC,
  isReview
}: ActionsCellProps) => {
  const options = useMemo(() => {
    const list: TButtonOptionProps[] = []
    if (canDelete) {
      list.push({
        text: BTN_TXT.DELETE,
        onClick: () => onDeleteCC?.(cc.uuid)
      })
    }
    if (canManageAssignment) {
      list.push({
        text: isReview ? BTN_TXT.REVIEW_ASSIGNMENT : BTN_TXT.MANAGE_ASSIGNMENT,
        onClick: () => setSelectedCC?.(cc)
      })
    }
    return list
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cc, canManageAssignment, canDelete, isReview])

  return (
    <Button.Menu
      icon={<More16 />}
      type={BUTTON_TYPES.GHOST}
      options={options}
      iconOnly
      hideArrow
    />
  )
}
